import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import Advertisement from './advertisement';
import Payable from './payable';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true,
  fullUrl: '',
});
const UpdateUnitMaster = ({ rowData, onClose }) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setloader] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState();
  
  // Master Listings
  const [measurementList, setMeasurementList] = useState([]);
  const [salersList, setSalesPersonList] = useState([]);
  const [bedRoomList, setBedRoomList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [communityList, setcommunityList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [imageView, setImageView] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [cityList, setCityList] = useState([]);
  // Unit Listings
  const [manDateList, setManDateList] = useState([]);
  const [reserveAccList, setReserveAccList] = useState([]);
  const [keyStatusList, setKeyStatusList] = useState([]);
  const [unitCostList, setUnitCostList] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [costAccount, setCostAccount] = useState([]);
  const [agent, setAgent] = useState([]);
  const [furnishing, setFurnishing] = useState([]);
  const [refferedBy, setRefferedBy] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [furniturePlan, setFurniturePlan] = useState([]);
  const [period, setPeriod] = useState([]);
  const [sizeType, setSizeType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const leaseData = rowData;
  const [unitAudit, setUnitAudit] = useState({ createdBy: '0', createdOn: null });
  const [recordStatus, setRecordStatus] = useState('');
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const [transectionData, setTransectionData] = useState({
    saller: null,
    landlordId: null,
    property: null,
    community: null,
    unitType: null,
    unitCategory: null,
    country: null,
    city: null,
    unitView: null,
    floor: null,
    bedRooms: null,
    unitNo: '',
    contactPerson: '',
    municipltyNo: '',
    refNo: '',
    unitClass: 'Sale',
    sector: '',
    block: '',
    bathRoom: '',
    balcony: '',
    livingarea: '',
    terraceArea: '',
    totalArea: '',
    netArea: '',
    parking: '',
    unitRate: '',
    remarks: '',
    parkingPrice: '',
    resale: false,
  });
  const [unitDetails, setUnitDetails] = useState({
    mandate: null,
    reservedAccCode: null,
    statusKey: null,
    unitCost: null,
    paymentPlan: null,
    status: null,
    costAccount: null,
    agent: null,
    furnishing: null,
    refferedBy: null,
    enteredBy: '0',
    furniturePlan: null,
    unitModel: '',
    serviceCharge: '',
    unitStyle: '',
    reservedFund: '',
    storeRoom: '',
    plotNO: '',
    company: '',
    financeOffered: '',
    rentAmount: '',
    plotSize: '',
    additionalWorkCost: '',
    streetNo: '',
    opt2Cost: '',
    opt3Cost: '',
    furnitureCost: '',
    occupied: false,
    propertyRegistered: false,
    mortgaged: false,
    leased: false,
    completionDate: '',
    expiryDate: formattedDate,
    reffferedDate: formattedDate,
    enteredDate: formattedDate,
    modifiedDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });
  const [advertisement, setAdvertisement] = useState({
    publishStatus: false,
    xmlFeed: false,
    openHouse: false,
    marketingDesc: '',
    remarks1: '',
    remarks2: '',
    remarks3: '',
  });

  useEffect(() => {
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
    if (!leaseData?.ref_No) {
      toast.warning(t('unitMaster.validationMessages.noUnitSelected'));
      if (onClose) onClose();
      return;
    }
    fetchDropdownData();
  }, [leaseData?.ref_No, onClose]);
  const fetchDropdownData = async () => {
    if (!leaseData?.ref_No) return;
    try {
      setTableLoading(true);
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMAreaMeasurements,UMSalesPersons,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods',
      );
      const res = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${params.toString()}`);
      const scndparams = new URLSearchParams();
      scndparams.append(
        'dropdownTypes',
        'UMSellerNames,UMReservedFundAccounts,UMAccounts,UMBanks,UMPaymentPlans,UMCountries,UMFurnished,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies',
      );
      const scndRes = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${scndparams.toString()}`);
      const d1 = res?.data?.dropdowns || {};
      const d2 = scndRes?.data?.dropdowns || {};
      setBedRoomList(d1.UMBedrooms);
      setCostAccount(d1.UMCostAccounts);
      setEnteredBy(d1.UMEnteredBy);
      setFloorList(d1.UMFloors);
      setImageView(d1.UMImageTypes);
      setKeyStatusList(d1.UMKeyStatus);
      setManDateList(d1.UMMandate);
      setPeriod(d1.UMPeriods);
      setPropertyList(d1.UMProperties);
      setRefferedBy(d1.UMReferredBy);
      setSizeType(d1.UMSizeTypes);
      setunitCategoryList(d1.UMUnitCategories);
      setunitViewList(d1.UMUnitViews);
      setUnitTypeList(d1.UMUnitTypes);
      setAgent(d2.UMAgents);
      setProjectStatus(d2.UMProjectStatus);
      setcommunityList(d2.UMCommunities);
      setMeasurementList(d2.UMAreaMeasurements);
      setUnitCostList(scndRes?.data?.dropdowns?.umenteredBy);
      setLandlordList(d2.UMSellers);
      setSalesPersonList(d2.UMSellers);
      setBankList(d2.UMBanks);
      setPaymentPlan(d2.UMPaymentPlans);
      setCountries(d2.UMCountries);
      setFurnishing(d2.UMFurnishing);
      setCurrency(d2.UMCurrencies);
      setFurniturePlan(d2.UMFurniturePlans);
      setReserveAccList(d2.UMReservedFundAccounts);

      const detailParams = new URLSearchParams();
      detailParams.append('Action', 'GetUnitDetailsByRefNo');
      detailParams.append('UnitRefNo', leaseData.ref_No);
      const unitRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${detailParams.toString()}`);
      const rawResult = unitRes?.data?.result;
      const ud =
        rawResult?.data !== undefined && typeof rawResult?.data === 'object' && !Array.isArray(rawResult.data)
          ? rawResult.data
          : typeof rawResult === 'object' && rawResult !== null
            ? rawResult
            : {};

      const pickNonZero = (...vals) => {
        for (const v of vals) {
          const s = v !== undefined && v !== null ? String(v).trim() : '';
          if (s !== '' && s !== '0') return v;
        }
        return '';
      };
      const propNo = pickNonZero(leaseData?.property_No, ud.Property_No, ud.property_No);
      if (propNo) {
        const fp = new URLSearchParams();
        fp.append('Action', 'GetUnitFeatureByRefNo');
        fp.append('UnitRefNo', leaseData.ref_No);
        const fRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${fp.toString()}`);
        setFeaturesList(fRes?.data?.result?.data || []);
      } else {
        setFeaturesList([]);
      }
      // Get Unit Images
      const imagesParam = new URLSearchParams();
      imagesParam.append('Action', 'GetUnitImagesByRefNo');
      imagesParam.append('UnitRefNo', leaseData.ref_No);
      const imgResp = await apiService.getApiParamater('UNIT_RA_COMMON', `?${imagesParam.toString()}`);
      const imgResult = imgResp?.data?.result?.data;
      debugger
      if (imgResult?.length || imgResult?.Record_Id) {
        if (imgResult?.length > 0) {
          const apiFiles = imgResult.map((item) => ({
            id: Date.now() + Math.random(),
            file: null,
            fileName: item.Image_Filename,
            remarks: '',
            filePath: item?.Folder,
            isNew: false,
            fullUrl: item.Url,
          }));
          setAttachments([...apiFiles, createEmptyRow()]);
        } else {
          const apiFiles = [{
            id: Date.now() + Math.random(),
            file: null,
            fileName: imgResult.Image_Filename,
            remarks: '',
            filePath: imgResult?.Folder,
            isNew: false,
            fullUrl: imgResult.Url,
          }];
          setAttachments([...apiFiles, createEmptyRow()]);
        }
      }
      const findOpt = (arr, text) => {
        const t = text !== undefined && text !== null ? String(text).trim() : '';
        if (!t || !arr?.length) return null;
        const row = arr.find((x) => String(x?.text ?? '').trim() === t || String(x?.value ?? '').trim() === t);
        return row ? { value: row, label: row.text } : { label: t, value: { text: t, value: t } };
      };
      const pick = (...vals) => {
        for (const v of vals) {
          if (v !== undefined && v !== null && String(v).trim() !== '') return v;
        }
        return '';
      };
      const parseApiDate = (val) => {
        if (!val) return '';
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? '' : d;
      };
      const valueOrEmpty = (...vals) => {
        const value = pick(...vals);

        return value === 0 ||
          value === "0" ||
          value === null ||
          value === undefined
          ? ""
          : String(value);
      };
      let cityOpts = [];
      const countryLabel = String(pick(ud.Country, ud.country) || '').trim();
      if (countryLabel && d2.UMCountries?.length) {
        const countryRow = d2.UMCountries.find((c) => c.text === countryLabel);
        if (countryRow) {
          const cityParams = new URLSearchParams();
          cityParams.append('DropdownFor', 'UMCitiesByCountry');
          cityParams.append('CascadValue', countryRow.text);
          const cityRes = await apiService.getApiParamater('UNIT_RA_CASCAD', `?${cityParams.toString()}`);
          cityOpts = cityRes?.data?.items || [];
        }
      }
      setCityList(cityOpts);

      const propName = pickNonZero(leaseData?.property_Name, ud.Property_Name, ud.property_Name);
      const propRow = d1.UMProperties?.find(
        (p) => (propNo && String(p.value) === String(propNo)) || (propName && String(p.text) === String(propName)),
      );
      const property = propRow
        ? { value: propRow, label: propRow.text }
        : propNo || propName
          ? { value: { value: propNo || '0', text: propName || String(propNo) }, label: propName || String(propNo) }
          : null;

      let communityName = '';
      if (propNo) {
        const communityParams = new URLSearchParams();
        communityParams.append('Action', 'GetCommunityByPropertyNo');
        communityParams.append('PropertyNo', propNo);
        const communityRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${communityParams.toString()}`);
        communityName = communityRes?.data?.result?.data?.Community_Name || '';
      }

      setUnitAudit({
        createdBy: String(pick(ud.Created_By, ud.createdBy, '0')),
        createdOn: parseApiDate(ud.Created_On || ud.createdOn) || today,
      });
      // Matches legacy GetRecord(): DBNull or the literal string "0" both mean "no status".
      setRecordStatus(String(ud.Status) === '0' ? '' : String(pick(ud.Status, '')));

      setTransectionData((prev) => ({
        ...prev,
        refNo: String(pick(leaseData.ref_No, ud.Ref_No)),
        unitNo: String(pick(leaseData.unit_No, ud.Unit_No)),
        unitClass: String(pick(leaseData.unit_Class, ud.Unit_Class, 'Sale')),
        property,
        country: findOpt(d2.UMCountries, pick(ud.Country, ud.Country)),
        city: findOpt(cityOpts, pick(ud.City, ud.City)),
        community: communityName ? { label: communityName, value: communityName } : findOpt(d2.UMCommunities, pick(ud.Community, ud.community_Name)),
        unitType: findOpt(d1.UMUnitTypes, pick(leaseData.unit_Type, ud.Unit_Type)),
        unitCategory: findOpt(d1.UMUnitCategories, pick(leaseData.unit_Category, ud.Unit_Category)),
        unitView: findOpt(d1.UMUnitViews, pick(leaseData.unit_View, ud.Unit_View)),
        floor: findOpt(d1.UMFloors, pick(leaseData.floor, ud.Floor)),
        bedRooms: findOpt(d1.UMBedrooms, pick(leaseData.bedrooms, ud.Bedrooms, ud.bedrooms)),
        totalArea: valueOrEmpty(pick(leaseData.total_Area, ud.Total_Area, prev.totalArea)),
        netArea: valueOrEmpty(pick(leaseData.measured_Area, ud.Measured_Area, prev.netArea)),
        unitRate: valueOrEmpty(pick(leaseData.sqft_Rate, ud.Sqft_Rate, prev.unitRate)),
        remarks: valueOrEmpty(pick(ud.Remarks, leaseData.remarks, prev.remarks)),
        block: valueOrEmpty(pick(ud.Block, prev.block)),
        bathRoom: valueOrEmpty(pick(ud.Bathrooms, ud.bathrooms, prev.bathRoom)),
        balcony: valueOrEmpty(pick(ud.Balcony, prev.balcony)),
        terraceArea: valueOrEmpty(pick(ud.Terrace, ud.terrace, prev.terraceArea)),
        livingarea: valueOrEmpty(pick(ud.LivingRooms, ud.livingRooms, prev.livingarea)),
        parking: valueOrEmpty(pick(leaseData.parking, ud.Parking, prev.parking)),
        parkingPrice: valueOrEmpty(pick(leaseData.parking_Price, ud.Parking_Price, prev.parkingPrice)),
        sector: valueOrEmpty(pick(ud.txtZone, ud.Unit_Zone, ud.Sector, prev.sector)),
        municipltyNo: valueOrEmpty(pick(ud.RERA_STR_No, ud.Rera_strNo, ud.RerA_STR_No, ud.Municipality_No, prev.municipltyNo)),
        saller: findOpt(d2.UMSellers, pick(ud.Seller_Name, ud.seller_Name)),
        landlordId: (() => {
          const opt = findOpt(d2.UMSellers, pick(ud.Seller_Id, ud.seller_Id));
          return opt ? { value: opt.value, label: opt.value?.value ?? opt.label } : null;
        })(),
        contactPerson: valueOrEmpty(pick(ud.Broker_Name, prev.contactPerson)),
      }));

      setUnitDetails((prev) => ({
        ...prev,
        unitModel: String(pick(ud.Unit_Model, prev.unitModel)),
        unitStyle: String(pick(ud.Unit_Style, prev.unitStyle)),
        streetNo: String(pick(ud.Street_No, prev.streetNo)),
        storeRoom: String(pick(ud.StoreRooms, leaseData.storeRooms, prev.storeRoom)),
        plotNO: String(pick(ud.Plot_No, leaseData.plot_No, prev.plotNO)),
        plotSize: String(pick(ud.Plot_Size, leaseData.plot_Size, prev.plotSize)),
        serviceCharge: String(pick(ud.ServiceCharge, prev.serviceCharge)),
        mandate: findOpt(d1.UMMandate, pick(ud.Mandate, prev.mandate?.label)),
        status: findOpt(d2.UMProjectStatus, pick(ud.PropertyType, ud.Status, leaseData.status, prev.status?.label)),
        unitCost: findOpt(d2.UMEnteredBy, pick(ud.Purchase_Value, prev.unitCost?.label)),
        paymentPlan: findOpt(d2.UMPaymentPlans, pick(ud.Payment_Plan, prev.paymentPlan?.label)),
        agent: findOpt(d2.UMAgents, pick(ud.Broker_Name, prev.agent?.label)),
        statusKey: findOpt(d1.UMKeyStatus, pick(ud.Key_Status, prev.statusKey?.label)),
        costAccount: findOpt(d1.UMCostAccounts, pick(ud.Exp9, ud.Cost_Account, prev.costAccount?.label)),
        furnishing: findOpt(d2.UMFurnishing, pick(ud.Facilities, prev.furnishing?.label)),
        refferedBy: findOpt(d1.UMReferredBy, pick(ud.Refered_By, ud.refered_By, prev.refferedBy?.label)),
        enteredBy: findOpt(d1.UMEnteredBy, pick(ud.Created_By, ud.Entered_By, prev.enteredBy?.label)),
        furniturePlan: findOpt(d2.UMFurniturePlans, pick(ud.PortfolioManager, ud.Furniture_Plan, prev.furniturePlan?.label)),
        furnitureCost: valueOrEmpty(pick(ud.Portfolio, prev.furnitureCost)),
        reservedFund: String(pick(ud.Advance_Deposit, prev.reservedFund)),
        reservedAccCode: findOpt(d2.UMReservedFundAccounts, pick(ud.Exp10, ud.Reserved_Account, prev.reservedAccCode?.label)),
        company: String(pick(ud.MortgageCompany, prev.company)),
        financeOffered: String(pick(ud.FinanceCompany, prev.financeOffered)),
        rentAmount: valueOrEmpty(pick(ud.LeaseAmount, prev.rentAmount)),
        completionDate: parseApiDate(ud.completion_Date) || prev.completionDate,
        expiryDate: parseApiDate(ud.LeaseExpiry ?? ud.leaseExpiry) || prev.expiryDate,
        reffferedDate: parseApiDate(ud.refered_On) || prev.reffferedDate,
        enteredDate: parseApiDate(ud.Created_On ?? ud.Entered_On) || prev.enteredDate,
        leased: Boolean(ud.Leased ?? leaseData.leased ?? prev.leased),
        occupied: Boolean(ud.OwnerOccupied ?? prev.occupied),
        propertyRegistered: Boolean(ud.PropertyRegistered ?? prev.propertyRegistered),
        mortgaged: Boolean(ud.Mortgaged ?? prev.mortgaged),
      }));

      setSalesDetails((prev) => ({
        ...prev,
        orignalPrice: valueOrEmpty(pick(ud.Total_Value, prev.orignalPrice)),
        listingPrice: valueOrEmpty(pick(ud.RoundOff_Value, prev.listingPrice)),
        priceinothercontry: valueOrEmpty(pick(ud.ListingPriceUSD, prev.priceinothercontry)),
        currency: findOpt(d2.UMCurrencies, pick(ud.Currency, prev.currency?.label)),
        profit: valueOrEmpty(pick(ud.Premium, prev.profit)),
        profitCalculate: valueOrEmpty(pick(ud.Premium_Percent, prev.profitCalculate)),
        mainSalePrice: valueOrEmpty(pick(ud.Measured_Value, prev.mainSalePrice)),
        marketAnalysis: valueOrEmpty(pick(ud.CMA_Range1, prev.marketAnalysis)),
        to: valueOrEmpty(pick(ud.CMA_Range2, prev.to)),
        legalFee: valueOrEmpty(pick(ud.Admin_Fees, prev.legalFee)),
        legalFeeCalcu: valueOrEmpty(pick(ud.Admin_Fees_Percent, prev.legalFeeCalcu)),
        miscFee: valueOrEmpty(pick(ud.Other_Fees, prev.miscFee)),
        miscFeeCalcu: valueOrEmpty(pick(ud.Other_Fees_Percent, prev.miscFeeCalcu)),
        comment: valueOrEmpty(pick(ud.Other_Fees_Remarks, prev.comment)),
        commSeller: valueOrEmpty(pick(ud.Seller_Commission, prev.commSeller)),
        commSellerCalculate: valueOrEmpty(pick(ud.Seller_Commission_Percent, prev.commSellerCalculate)),
        commPaid: valueOrEmpty(pick(ud.Buyer_Commission, prev.commPaid)),
        commPaidCalculate: valueOrEmpty(pick(ud.Buyer_Commission_Percent, prev.commPaidCalculate)),
        sellerTransferFee: valueOrEmpty(pick(ud.Seller_TransferFee, prev.sellerTransferFee)),
        sellerTransferFeeCalcu: valueOrEmpty(pick(ud.Seller_TransferFee_Percent, prev.sellerTransferFeeCalcu)),
        buyerTransferFee: valueOrEmpty(pick(ud.Buyer_TransferFee, prev.buyerTransferFee)),
        buyerTransferFeeCalcu: valueOrEmpty(pick(ud.Buyer_TransferFee_Percent, prev.buyerTransferFeeCalcu)),
        sellerPaidDev: valueOrEmpty(pick(ud.Seller_Paid, prev.sellerPaidDev)),
        sellerPaidDevCalcu: valueOrEmpty(pick(ud.Seller_Paid_Percent, prev.sellerPaidDevCalcu)),
      }));

      // The % fields are never persisted separately by the legacy app — they're recomputed
      // from the loaded amounts and Rent Per Annum, not read from the database.
      setLeaseDetails((prev) => {
        const rentPerAnumVal = parseFloat(pick(leaseData.rent_Per_Annum, ud.Rent_Per_Annum, prev.rentPerAnum)) || 0;
        const pctOfRentPerAnum = (amt) => {
          const a = parseFloat(amt) || 0;
          return rentPerAnumVal ? ((a / rentPerAnumVal) * 100).toFixed(4) : '';
        };
        const securityDepositVal = pick(ud.Security_Deposit, prev.securityDeposit);
        const tenantCommissionVal = pick(ud.Tenant_Commission, prev.tenantCommission);
        const landlordCommissionVal = pick(ud.Landlord_Commission, prev.landlordCommission);
        return {
          ...prev,
          rentPerAnum: valueOrEmpty(pick(leaseData.rent_Per_Annum, ud.Rent_Per_Annum, prev.rentPerAnum)),
          rentByMonth: valueOrEmpty(pick(ud.Short_Term_Rent, prev.rentByMonth)),
          rentPerDay: valueOrEmpty(pick(ud.Rent_Per_Day, prev.rentPerDay)),
          securityDeposit: valueOrEmpty(securityDepositVal),
          securityDepositPerc: pctOfRentPerAnum(securityDepositVal) || prev.securityDepositPerc,
          tenantCommission: valueOrEmpty(tenantCommissionVal),
          tenantCommissionPerc: pctOfRentPerAnum(tenantCommissionVal) || prev.tenantCommissionPerc,
          landlordCommission: valueOrEmpty(landlordCommissionVal),
          landlordCommissionPerc: pctOfRentPerAnum(landlordCommissionVal) || prev.landlordCommissionPerc,
          maintenanceFee: valueOrEmpty(pick(ud.Maintenance_Fee, prev.maintenanceFee)),
          dueDate: parseApiDate(ud.Effeciency) || prev.dueDate,
          installment: valueOrEmpty(pick(ud.Installments, prev.installment)),
          bankName: findOpt(d2.UMBanks, pick(ud.RentBankName, prev.bankName?.label)),
          accountNo: valueOrEmpty(pick(ud.RentBankAcNo, prev.accountNo)),
          rentPayable: valueOrEmpty(pick(ud.RentPayableTo, prev.rentPayable)),
          IbanNo: valueOrEmpty(pick(ud.Street_Name, prev.IbanNo)),
          secDepositPayable: valueOrEmpty(pick(ud.SecDepPayableTo, prev.secDepositPayable)),
          commissionPayable: valueOrEmpty(pick(ud.ComPayableTo, prev.commissionPayable)),
          fixedCharges: valueOrEmpty(pick(ud.MonthlyIncome, prev.fixedCharges)),
          variableCharges: valueOrEmpty(pick(ud.AnnualIncome, prev.variableCharges)),
        };
      });

      setAdvertisement((prev) => ({
        ...prev,
        // PublishStatus is stored as the literal string "True"/"False", not a real bit —
        // a plain Boolean(...) would incorrectly treat the string "False" as truthy.
        publishStatus: pick(ud.PublishStatus, prev.publishStatus) === 'True' || pick(ud.PublishStatus, prev.publishStatus) === true,
        xmlFeed: Boolean(ud.Adv_Listing ?? prev.xmlFeed),
        openHouse: Boolean(ud.Adv_OpenHouse ?? prev.openHouse),
        marketingDesc: valueOrEmpty(pick(ud.Remarks, prev.marketingDesc)),
        remarks1: valueOrEmpty(pick(ud.Adv_Remarks1, prev.remarks1)),
        remarks2: valueOrEmpty(pick(ud.Adv_Remarks2, prev.remarks2)),
        remarks3: valueOrEmpty(pick(ud.Adv_Remarks3, prev.remarks3)),
      }));

      // const fileparams = new URLSearchParams();
      // fileparams.append('refNo', String(leaseData.ref_No));
      // fileparams.append('fileCategory', 'Images');
      // const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
      // if (imgRes?.data?.result?.length) {
      //   const apiFiles = imgRes.data.result.map((item) => ({
      //     id: Date.now() + Math.random(),
      //     file: null,
      //     fileName: item.fileName,
      //     remarks: '',
      //     filePath: item?.filePath,
      //     isNew: false,
      //     fullUrl: item.fullUrl,
      //   }));
      //   setAttachments([...apiFiles, createEmptyRow()]);
      // }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      toast.error('Could not load unit for editing');
    } finally {
      setTableLoading(false);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  // Mirrors the legacy rbSale/rbLease/rbPropertyManagement_CheckedChanged tab-set logic.
  // Yearly Rent is always omitted for now — its visibility depends on a system setting
  // (checkMultiYrLease / tbLease_Setting) with no API exposed to the frontend yet.
  const getTabList = () => {
    const list = [
      { key: 'unitMaster', label: t('unitMaster.tabs.unitMaster') },
      { key: 'unitDetails', label: t('unitMaster.tabs.unitDetails') },
      { key: 'unitFeatures', label: t('unitMaster.tabs.unitFeatures') },
    ];
    const unitClass = transectionData?.unitClass || 'Sale';
    if (unitClass === 'Lease') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.leaseDetails') });
      if (String(transectionData?.unitType?.label || '').toUpperCase() === 'COMMERCIAL') {
        list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
      }
    } else if (unitClass === 'PM') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.pmDetails') });
      list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
    } else {
      list.push({ key: 'salesDetails', label: t('unitMaster.tabs.salesDetails') });
      list.push({ key: 'buyerSummary', label: t('unitMaster.tabs.buyerSummary') });
    }
    list.push({ key: 'advertisement', label: t('unitMaster.tabs.advertisement') });
    list.push({ key: 'images', label: t('unitMaster.tabs.images') });
    return list;
  };
  const tabList = getTabList();
  // The tab set changes shape with Unit Class, so a stale index could point at a
  // different tab (or nothing) after switching — reset to the first tab instead.
  useEffect(() => {
    setActiveTab(0);
  }, [transectionData?.unitClass]);
  const handleBackClick = () => {
    if (onClose) onClose();
  };

  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item) => ({
      status: item?.DescType || '0',
      description: item?.Description || '0',
      value: item?.Value,
      cnt: parseFloat(item?.Cnt) || 0,
      amount: parseFloat(item?.Amount) || 0,
      isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
    }));
    const image = data?.map((item) => ({
      record_Id: 0,
      image_Description: item?.originalFileName || '0',
      image_Filename: item?.fileName || '0',
      isDefault: true,
      folder: item?.filePath || '0',
      url: item?.fullUrl || '0',
      isAdded: true,
      isUpdated: false,
      isDeleted: false,
    }));
    const body = {
      refNo: refNo || '0',
      unitFeatures,
      unitImages: image,
      unitPayables: [{ description: '0', value: true, landlord: true, tenant: true }],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [{ description: '0', amount: 0 }],
    };
    await apiService.post('POST_UNIT_ADDITIONAL', body);
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    // formData.append('refNo', "");
    formData.append('fileCategory', 'Images');

    // ✅ DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post('https://lease.api.apps.rabahrain.com/api/FileUpload/files', formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    if (response?.data) {
      return response?.data?.result || [];
      // additionalDataUpload(response?.data?.result, ref_No);
    }
  };

  // "Amount due to Developer" is always the complement of "Seller has Paid to Developer".
  const amountDueDev = (parseFloat(salesDetails?.orignalPrice) || 0) - (parseFloat(salesDetails?.sellerPaidDev) || 0);
  const amountDueDevPercent = 100 - (parseFloat(salesDetails?.sellerPaidDevCalcu) || 0);
  const handleSave = async () => {
    try {
      setloader(true);
      // Edit flow: do not block save on client validation; API accepts defaults (e.g. "0") for optional fields.

      const completionDateIso = (() => {
        const c = unitDetails?.completionDate;
        if (!c) return today.toISOString();
        if (c instanceof Date && !Number.isNaN(c.getTime())) return c.toISOString();
        const d = new Date(c);
        return Number.isNaN(d.getTime()) ? today.toISOString() : d.toISOString();
      })();
      const unitFeatures = featuresList?.map((item) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value:
            typeof item?.Value === 'boolean'
              ? item.Value
              : String(item?.Value).toLowerCase() === 'true',
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      let uploadedFiles = []
      const hasNewFiles = attachments?.some((item) => item.file instanceof File && item.isNew);
      if (hasNewFiles) {
        uploadedFiles = await handleUpload();
      }
      const unitImages = attachments
        ?.filter((item) => (item.isNew && item.file instanceof File) || (!item.isNew && item.fileName))
        .map((item) => {
          if (item.isNew) {
            const uploadedFile = uploadedFiles.find(
              (file) => file.originalFileName === item.file?.name
            );
            return {
              record_Id: 0,
              image_Description: '0',
              image_Filename: uploadedFile?.fileName || '0',
              isDefault: true,
              folder: '0',
              url: uploadedFile?.fullUrl || '0',
              isAdded: true,
              isUpdated: false,
              isDeleted: false,
            };
          }

          return {
            record_Id: 0,
            image_Description: '0',
            image_Filename: item.fileName || '0',
            isDefault: true,
            folder: item.filePath || '0',
            url: item.fullUrl || '0',
            isAdded: false,
            isUpdated: false,
            isDeleted: false,
          };
        });
      const body = {
        unitMasterMain: {
          unitMaster: {
            ref_No: transectionData?.refNo || '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: transectionData?.municipltyNo || '0',
            street_No: unitDetails?.streetNo || '0',
            street_Name: leaseDetails?.IbanNo || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: unitDetails?.unitStyle || '0',
            unit_Model: unitDetails?.unitModel || '0',
            unit_Zone: transectionData?.sector || '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: transectionData?.block || '0',
            floor: transectionData?.floor?.label || '0',
            unit_View: transectionData?.unitView?.label || '0',
            completion_Date: completionDateIso,
            unit_Class: transectionData?.unitClass || '0',
            livingRooms: transectionData?.livingarea || '0',
            bedrooms: transectionData?.bedRooms?.label || '0',
            storeRooms: unitDetails?.storeRoom || '0',
            parking: transectionData?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: recordStatus || '0',
            payment_Plan: unitDetails?.paymentPlan?.label || '0',
            broker_Name: unitDetails?.agent?.label || '0',
            seller_Id: transectionData?.landlordId?.label || '0',
            seller_Name: transectionData?.saller?.label || '0',
            adv_Listing: Boolean(advertisement?.xmlFeed),
            adv_NewsPaper: false,
            adv_Web: false,
            adv_OpenHouse: Boolean(advertisement?.openHouse),
            adv1: false,
            adv2: false,
            adv3: false,
            adv_Remarks1: advertisement?.remarks1 || '0',
            adv_Remarks2: advertisement?.remarks2 || '0',
            adv_Remarks3: advertisement?.remarks3 || '0',
            remarks: advertisement?.marketingDesc || '0',
            internalRemarks: transectionData?.remarks || '0',
            otherSpace1: '0',
            bathrooms: transectionData?.bathRoom || '0',
            balcony: transectionData?.balcony || '0',
            terrace: transectionData?.terraceArea || '0',
            total_Area: parseFloat(transectionData?.totalArea) || 0,
            measured_Area: parseFloat(transectionData?.netArea) || 0,
            sqft_Rate: parseFloat(transectionData?.unitRate || 0),
            purchase_Value: parseFloat(unitDetails?.unitCost?.label) || 0,
            total_Value: parseFloat(salesDetails?.orignalPrice) || 0,
            measured_Value: parseFloat(salesDetails?.mainSalePrice) || 0,
            roundOff_Value: parseFloat(salesDetails?.listingPrice) || 0,
            parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
            all_In_Price:
              (parseFloat(salesDetails?.profit) || 0) +
              (parseFloat(salesDetails?.sellerPaidDev) || 0) +
              amountDueDev +
              (parseFloat(salesDetails?.commPaid) || 0) +
              (parseFloat(salesDetails?.buyerTransferFee) || 0) +
              (parseFloat(salesDetails?.legalFee) || 0) +
              (parseFloat(salesDetails?.miscFee) || 0),
            premium: parseFloat(salesDetails?.profit) || 0,
            premium_Percent: parseFloat(salesDetails?.profitCalculate) || 0,
            seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
            seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
            buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
            buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
            seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
            seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
            buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
            buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
            admin_Fees: parseFloat(salesDetails?.legalFee) || 0,
            admin_Fees_Percent: parseFloat(salesDetails?.legalFeeCalcu) || 0,
            other_Fees: parseFloat(salesDetails?.miscFee) || 0,
            other_Fees_Percent: parseFloat(salesDetails?.miscFeeCalcu) || 0,
            other_Fees_Remarks: salesDetails?.comment || '0',
            seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
            seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
            developer_Due: amountDueDev,
            developer_Due_Percent: amountDueDevPercent,
            rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
            short_Term_Rent: parseFloat(leaseDetails?.rentByMonth) || 0,
            short_Term_Period: '0',
            rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
            security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
            advance_Deposit: parseFloat(unitDetails?.reservedFund) || 0,
            tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
            landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
            maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
            negotiable: true,
            currency: salesDetails?.currency?.label || '0',
            cmA_Range1: parseFloat(salesDetails?.marketAnalysis) || 0,
            cmA_Range2: parseFloat(salesDetails?.to) || 0,
            installments: parseFloat(leaseDetails?.installment) || 0,
            rentPayableTo: leaseDetails?.rentPayable || '0',
            rentBankName: leaseDetails?.bankName?.label || '0',
            rentBankAcNo: leaseDetails?.accountNo || '0',
            secDepPayableTo: leaseDetails?.secDepositPayable || '0',
            comPayableTo: leaseDetails?.commissionPayable || '0',
            key_Status: unitDetails?.statusKey?.label || '0',
            publishStatus: Boolean(advertisement?.publishStatus),
            publishDate: advertisement?.publishStatus ? new Date() : new Date('1900-01-01'),
            serviceCharge: unitDetails?.serviceCharge || '0',
            ownerOccupied: Boolean(unitDetails?.occupied ?? true),
            leased: Boolean(unitDetails?.leased),
            leaseAmount: parseFloat(unitDetails?.rentAmount) || 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: unitDetails?.mandate?.label || '0',
            financeCompany: unitDetails?.financeOffered || '0',
            mortgaged: Boolean(unitDetails?.mortgaged ?? true),
            mortgageCompany: unitDetails?.company || '0',
            propertyRegistered: Boolean(unitDetails?.propertyRegistered ?? true),
            portfolio: parseFloat(unitDetails?.furnitureCost) || 0,
            portfolioManager: unitDetails?.furniturePlan?.label || '0',
            propertyType: unitDetails?.status?.label || '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: leaseDetails?.dueDate,
            listingPriceUSD: parseFloat(salesDetails?.priceinothercontry) || 0,
            monthlyIncome: (parseFloat(leaseDetails?.fixedCharges) || 0).toFixed(3),
            annualIncome: (parseFloat(leaseDetails?.variableCharges) || 0).toFixed(3),
            exp9: unitDetails?.costAccount?.label || '0',
            exp10: unitDetails?.reservedAccCode?.label || '0',
            refered_By: unitDetails?.refferedBy?.label || '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: unitDetails?.enteredBy?.label || '0',
            createdOn: unitDetails?.enteredDate,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitImages: unitImages,
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const putRes = await apiService.put('UPDATE_UNIT_RA', body);
      if (putRes?.data?.statusCode === 200 || putRes?.data?.statusCode === 201) {
        const refNo = transectionData?.refNo || leaseData?.ref_No;
        // await handleUpload(refNo);
        toast.success(putRes?.data?.message);
        setloader(false);
        if (onClose) onClose();
      } else {
        toast.warning(`${putRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  return (
    <div className="d-flex flex-column unit-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <h5 className="mb-0">{t('unitMaster.editFormTitle')}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4 unit-modal-tabs">
          {tabList.map((tab, index) => (
            <div
              key={tab.key}
              className={`dashitems sidebar-text center ${activeTab === index ? 'sideActive' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      {tabList[activeTab]?.key === 'unitMaster' && (
        <MasterDetails
          isEdit
          statusText={recordStatus}
          tableLoading={tableLoading}
          countriesList={countriesList}
          salersList={salersList}
          setCityList={setCityList}
          setTransectionData={setTransectionData}
          propertyList={propertyList}
          cityList={cityList}
          setFeaturesList={setFeaturesList}
          transectionData={transectionData}
          landlordList={landlordList}
          communityList={communityList}
          unitTypeList={unitTypeList}
          unitViewList={unitViewList}
          floorList={floorList}
          unitCategoryList={unitCategoryList}
          setcommunityList={setcommunityList}
          setunitCategoryList={setunitCategoryList}
          bedRoomList={bedRoomList}
        />
      )}
      {tabList[activeTab]?.key === 'unitDetails' && (
        <UnitDetails
          tableLoading={tableLoading}
          manDateList={manDateList}
          reserveAccList={reserveAccList}
          agent={agent}
          setTransectionData={setUnitDetails}
          keyStatusList={keyStatusList}
          unitCostList={unitCostList}
          paymentPlan={paymentPlan}
          furnishing={furnishing}
          transectionData={unitDetails}
          projectStatus={projectStatus}
          costAccount={costAccount}
          refferedBy={refferedBy}
          enteredBy={enteredBy}
          furniturePlan={furniturePlan}
        />
      )}
      {tabList[activeTab]?.key === 'unitFeatures' && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
      {tabList[activeTab]?.key === 'salesDetails' && (
        <SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} totalArea={transectionData?.totalArea} />
      )}
      {tabList[activeTab]?.key === 'buyerSummary' && <BuyerSummery tableLoading={tableLoading} salesDetails={salesDetails} />}
      {tabList[activeTab]?.key === 'leaseDetails' && (
        <LeaseDetails
          tableLoading={tableLoading}
          setTransectionData={setLeaseDetails}
          transectionData={leaseDetails}
          bankList={bankList}
          unitClass={transectionData?.unitClass}
        />
      )}
      {tabList[activeTab]?.key === 'payable' && <Payable tableLoading={tableLoading} />}
      {tabList[activeTab]?.key === 'advertisement' && (
        <Advertisement tableLoading={tableLoading} setTransectionData={setAdvertisement} transectionData={advertisement} />
      )}
      {tabList[activeTab]?.key === 'images' && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} setDeletedFiles={setDeletedFiles} deletedFiles={deletedFiles}/>}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {loading === true ? (
          <div className="mainbtn flex-end gap-2">
            <ClipLoader color="#ffffff" className="mt-1" size={20} />
          </div>
        ) : (
          <div className="mainbtn flex-end gap-2" onClick={handleSave}>
            <FaSave color="#fff" className="center mt-1 mx-2" />
            <div className="center">{t('common.save')}</div>
          </div>
        )}
        <div className="mainbtnRed flex-end gap-2" onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default UpdateUnitMaster;
